const PAYMENT_TYPES = {
    SUCCESS: ['succeeded', 'paid', 'requires_capture', 'completed', 'APPROVED', 'COMPLETED'],
    FAILURE: ['failure', 'CANCELED', 'FAILED'],
};

export default PAYMENT_TYPES;